module.exports = __webpack_public_path__ + "img/fog_1.1d48ab7e.png";